import React,{useState,useEffect,useRef} from 'react';
//import logo from './logo.svg';
import './App.css';

import i18n from "i18next";
import { useTranslation, initReactI18next, Trans } from "react-i18next";

const PRICE_TABLE = {
  '€': {
    visitcard: { oneshot: 0, monthly: 19.90 },
    professional: {
      website: { oneshot: 3990, monthly: 49.90 },
      mobileapp: { oneshot: 6990, monthly: 69.90 }
    },
    premium: {
      website: { oneshot: 7990, monthly: 99.90 },
      mobileapp: { oneshot: 12990, monthly: 149.90 }
    }
  },
  '$': {
    visitcard: { oneshot: 0, monthly: 21.90 },
    professional: {
      website: { oneshot: 4190, monthly: 49.90 },
      mobileapp: { oneshot: 7390, monthly: 69.90 }
    },
    premium: {
      website: { oneshot: 6549, monthly: 99.90 },
      mobileapp: { oneshot: 6990, monthly: 149.90 }
    }
  },
  '£': {
    visitcard: { oneshot: 0, monthly: 19.90 },
    professional: {
      website: { oneshot: 3290, monthly: 40.90 },
      mobileapp: { oneshot: 5790, monthly: 59.90 }
    },
    premium: {
      website: { oneshot: 6690, monthly: 82.90 },
      mobileapp: { oneshot: 10790, monthly: 124.90 }
    }
  },
  '₾': {
    visitcard: { oneshot: 0, monthly: 59.90 },
    professional: {
      website: { oneshot: 11990, monthly: 149.90 },
      mobileapp: { oneshot: 20990, monthly: 209.90 }
    },
    premium: {
      website: { oneshot: 23990, monthly: 299.90 },
      mobileapp: { oneshot: 38990, monthly: 449.90 }
    }
  }
};

const EN_TRANSLATIONS = {
  "hello@mafate.co": "hello@mafate.co.uk",
  "Welcome to React": "Welcome to React and react-i18next",
  "Pricing": "Pricing",
  "Contact Us": "Contact Us",
  "Schedule Appointments": "Schedule Appointments",
  "Free Online Appointment": "Free Online Appointment",
  "Home": "Home",
  "Services": "Services",
  "Our Services": "Our Services",
  "Follow Us": "Follow Us",
  "On Facebook": "on Facebook",
  "On Instagram": "on Instagram",
  //"Mobile Application": "",
  //"Website": "Website",
  "We're building your": "We're building your",
  "Choose": "Choose <bold>efficiency</bold> and <bold>quickness</bold> !",
  "ServicesBlockLine1": "Take care of your digital project",
  "Domain Name": "Domain Name",
  "Domain": "Domain",
  "We are booking your domain": "We are booking your domain",
  "Email Account": "Email Account",
  "Your professional emails like xyz@mycompany.com": "Your professional emails like xyz@mycompany.com",
  "Mobile Application": "Mobile Application",
  "Mobile_Application_PLURAL": "Mobile Applications",
  "Your iOS & Android mobile application": "Your iOS & Android mobile application",
  "Website": "Website",
  "Your personnalised website": "Your personnalised website",
  "Your responsive website": "Your responsive website",
  "Your mobile app on": "Your mobile app on",
  "WebsiteOnlyInEnglish": " Website",
  "from": "from",
  "access included in the monthly subscription": " access included in the monthly subscription",
  "multilingual_line": "<strong>Multilingual</strong>",
  "10 hours of on-demand development included": "10 hours of <strong>on-demand development</strong> included",
  "PricingBlockTitle": "Transparent Pricing",
  "PricingBlockLine1": "We value transparency & simplicity.",
  "PricingBlockLine2": "",
  "ContactBlockLine1": "We will answer in the next 24hours",
  "ContactBlockLine2": "Any questions, contact-us",
  "Personnalisation_template": "We personnalise a <strong>template</strong> with your colors",
  "Personnalisation_premium": "We will integrate your graphical charter",
  "Name": "Name",
  "Company": "Company",
  "Email": "Email",
  "Phone": "Phone",
  "Address": "Address",
  "address_value": "Elizbar Mindeli street, N 7b, floor 13, apartment N112 Georgia, Tbilisi, Vake district",
  "Identification": "Identification",
  "identification_value": "IE 305460916",
  "Your Message": "Your Message",
  "Your details": "Your details",
  "Booking an online appointment": "Booking an online appointment",
  "Send": "Send",
  "Subscribe": "Subscribe",
  "to our newsletter": "to our newsletter",
  "btnSubscribe": "Subscribe",
  "Terms of Use": "Terms of Use",
  "Privacy Policy": "Privacy Policy",
  "month": "month",
  "then": "then",
  "Technology": "Technology",
  "Hosting": "Hosting",
  "included": "included",
  "email account": "email account",
  "Cookies management": "Cookies management",
  "GDPR Compliant": "GDPR Compliant",
  "User authentification": "User authentification",
  "Administration Panel": "Administration Panel",
  "Easy to use": "Easy-to-use ",
  "simple d'utilisation": "",
  "Up to": "Up to",
  "Currency": "Currency",
  "modules_liste_onpricingblock": "presentation, blog/news, prestations, FAQ, customer reviews, menu, concours, agenda, photo gallery, videos, appointment, booking, lexicon, contact/maps",
  "accroche_bas": "<strong>Quickness</strong> & <strong>efficiency</strong> fairly-priced</strong> !",
  "AVAILABLE": "AVAILABLE",
  "Remove": "Remove"
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)

    resources: {
      en: {
        translation: EN_TRANSLATIONS
      },
      fr: {
        translation: {
          "hello@mafate.co": "bonjour@mafate.fr",
          "Welcome to React": "Bienvenue to React and react-i18next",
          "Pricing": "Tarifs",
          "Contact Us": "Nous Contacter",
          "Schedule Appointments": "Prendre RDV",
          "Free Online Appointment": "Planifier un RDV en ligne",
          "Home": "Accueil",
          "Services": "Services",
          "Our Services": "Nos Services",
          "Follow Us": "Suivez-nous",
          "On Facebook": "sur Facebook",
          "On Instagram": "sur Instagram",
          //"Mobile Application": "Application Mobile",
          //"Website": "Site Internet",
          "We're building your": "Nous réalisons votre",
          "Choose": "Choisissez l'<bold>efficience</bold> et la <bold>rapidité</bold>, au juste prix !",
          "ServicesBlockLine1": "Confiez-nous vos projets",
          "Domain Name": "Nom de domaine",
          "Domain": "Domaine",
          "Email Account": "Comptes Email Pro",
          "Your professional emails like xyz@mycompany.com": "Vos emails du type xyz@votreentreprise.com",
          "We are booking your domain": "On réserve votre nom de domaine",
          "Mobile Application": "Application Mobile",
          "Mobile Application PLURAL": "Applications Mobiles",
          "Your iOS & Android mobile application": "Votre application mobile disponible sur iOS et Android",
          "Website": "Site Internet",
          "Your personnalised website": "Votre site internet personnalisé",
          "Your responsive website": "Votre site internet responsive",
          "Your mobile app on": "Votre application mobile",
          "WebsiteOnlyInEnglish": " Website",
          "from": "dès",
          "access included in the monthly subscription": " (accès) inclus dans l'abonnement mensuel",
          "multilingual_line": "<strong>Multilingue</strong>",
          "10 hours of on-demand development included": "10 heures de <strong>développement sur-mesure</strong> inclus",
          "PricingBlockTitle": "Une tarification simple et transparente",
          "PricingBlockLine1": "Chez Mafate.co la transparence et la simplicité sont des valeurs fondamentales.",
          "PricingBlockLine2": "Nos tarifs sont en libre accès, vous pouvez savoir dès à présent combien vous coûtera votre projet.",
          "ContactBlockLine1": "Réponse sous 24h",
          "ContactBlockLine2": "Vous avez des questions, contactez-nous dès à présent.",
          "Personnalisation_template": "Personnalisation d'un <strong>template</strong> à vos couleurs",
          "Personnalisation_premium": "Intégration de votre propre <strong>charte graphique</strong>",
          "Name": "Nom & Prénom",
          "Company": "Société",
          "Email": "Email",
          "Phone": "Téléphone",
          "Address": "Adresse",
          "address_value": "Elizbar Mindeli street, N 7b, floor 13, apartment N 112 Georgia, Tbilisi, Vake district",
          "Identification": "Identification",
          "identification_value": "IE 305460916",
          "Your Message": "Votre message",
          "Your details": "Vos informations",
          "Booking an online appointment": "Prendre rendez-vous en ligne",
          "Send": "Send",
          "Subscribe": "Inscrivez-vous",
          "to our newsletter": "à notre newsletter",
          "btnSubscribe": "Inscription",
          "Terms of Use": "CGU",
          "Privacy Policy": "Politique de confidentialité",
          "month": "mois",
          "then": "puis",
          "Technology": "Technologie",
          "Hosting": "Hébergement",
          "included": "inclus",
          "email account": "compte email",
          "Cookies management": "Gestion des cookies",
          "GDPR Compliant": "conforme RGPD",
          "User authentification": "Connexion Utilisateur",
          "Administration Panel": "Panneau d'administration",
          "Easy to use": "",
          "simple d'utilisation": " simple d'utilisation",
          "Up to": "Jusqu'à",
          "Currency": "Devise",
          "modules_liste_onpricingblock": "présentation, blog, prestations, FAQ, avis client, menu, concours, agenda, photos, vidéos, prise de rendez-vous, réservations, lexique, contacts/plans",
          "accroche_bas": "<strong>Rapidité</strong> et <strong>efficience</strong> au <strong>Juste Prix</strong> !",
          "AVAILABLE": "DISPONIBLE",
          "Remove": "Retirer"
        }
      },
      ge: {
        translation: {
          "hello@mafate.co": "hello@mafate.ge",
          "Welcome to React": "მოგესალმებით React-ში",
          "Pricing": "ფასები",
          "Contact Us": "დაგვიკავშირდით",
          "Schedule Appointments": "შეხვედრის დაგეგმვა",
          "Free Online Appointment": "უფასო ონლაინ შეხვედრა",
          "Home": "მთავარი",
          "Services": "სერვისები",
          "Our Services": "ჩვენი სერვისები",
          "Follow Us": "გამოგვყევით",
          "On Facebook": "ფეისბუქზე",
          "On Instagram": "ინსტაგრამზე",
          "We're building your": "ჩვენ ვქმნით თქვენს",
          "Choose": "აირჩიეთ <bold>ეფექტურობა</bold> და <bold>სისწრაფე</bold>, სამართლიან ფასად!",
          "ServicesBlockLine1": "მოგვანდეთ თქვენი პროექტები",
          "Domain Name": "დომენის სახელი",
          "Domain": "დომენი",
          "Email Account": "ელფოსტის ანგარიში",
          "Your professional emails like xyz@mycompany.com": "თქვენი პროფესიონალური ელფოსტები, მაგალითად xyz@mycompany.com",
          "We are booking your domain": "ჩვენ ვარეზერვებთ თქვენს დომენს",
          "Mobile Application": "მობილური აპლიკაცია",
          "Mobile Application PLURAL": "მობილური აპლიკაციები",
          "Your iOS & Android mobile application": "თქვენი iOS და Android მობილური აპლიკაცია",
          "Website": "ვებგვერდი",
          "Your personnalised website": "თქვენი პერსონალიზებული ვებგვერდი",
          "Your responsive website": "თქვენი რესპონსიული ვებგვერდი",
          "Your mobile app on": "თქვენი მობილური აპლიკაცია",
          "WebsiteOnlyInEnglish": " ვებგვერდი",
          "from": "დან",
          "access included in the monthly subscription": " წვდომა შედის ყოველთვიურ გამოწერაში",
          "multilingual_line": "<strong>მრავალენოვანი</strong>",
          "10 hours of on-demand development included": "10 საათი <strong>მოთხოვნის საფუძველზე განვითარების</strong> შედის",
          "PricingBlockTitle": "მარტივი და გამჭვირვალე ფასები",
          "PricingBlockLine1": "Mafate.co-ში გამჭვირვალობა და სიმარტივე ძირითადი ღირებულებებია",
          "PricingBlockLine2": "ჩვენი ფასები ღიაა, შეგიძლიათ ახლავე გაიგოთ თქვენი პროექტის ფასი",
          "ContactBlockLine1": "პასუხი 24 საათში",
          "ContactBlockLine2": "კითხვები გაქვთ? დაგვიკავშირდით ახლავე",
          "Personnalisation_template": "თქვენი ფერებით <strong>შაბლონის</strong> პერსონალიზაცია",
          "Personnalisation_premium": "თქვენი <strong>გრაფიკული ჩარტერის</strong> ინტეგრაცია",
          "Name": "სახელი და გვარი",
          "Company": "კომპანია",
          "Email": "ელ.ფოსტა",
          "Phone": "ტელეფონი",
          "Address": "მისამართი",
          "address_value": "საქართველო, თბილისი, ვაკის რაიონი, ელიზბარ მინდელის ქუჩა, N 7ბ, სართული 13, ბინა N 112",
          "Identification": "საიდენტიფიკაციო ნომერი",
          "identification_value": "IE 305460916",
          "Your Message": "თქვენი შეტყობინება",
          "Your details": "თქვენი ინფორმაცია",
          "Booking an online appointment": "ონლაინ შეხვედრის დაჯავშნა",
          "Send": "გაგზავნა",
          "Subscribe": "გამოწერა",
          "to our newsletter": "ჩვენს სიახლეებს",
          "btnSubscribe": "გამოწერა",
          "Terms of Use": "გამოყენების პირობები",
          "Privacy Policy": "კონფიდენციალურობის პოლიტიკა",
          "month": "თვე",
          "then": "შემდეგ",
          "Technology": "ტექნოლოგია",
          "Hosting": "ჰოსტინგი",
          "included": "შედის",
          "email account": "ელფოსტის ანგარიში",
          "Cookies management": "ქუქიების მართვა",
          "GDPR Compliant": "GDPR-ის შესაბამისი",
          "User authentification": "მომხმარებლის ავთენტიფიკაცია",
          "Administration Panel": "ადმინისტრირების პანელი",
          "Easy to use": "გამოყენება მარტივია",
          "simple d'utilisation": " მარტივად გამოსაყენებელი",
          "Up to": "მდე",
          "Currency": "ვალუტა",
          "modules_liste_onpricingblock": "პრეზენტაცია, ბლოგი, მომსახურებები, FAQ, კლიენტების შეფასებები, მენიუ, კონკურსი, კალენდარი, ფოტოები, ვიდეოები, შეხვედრების დაჯავშნა, ჯავშნები, ლექსიკონი, კონტაქტები/რუკები",
          "accroche_bas": "<strong>სისწრაფე</strong> და <strong>ეფექტურობა</strong> <strong>სამართლიან ფასად</strong> !",
          "AVAILABLE": "ხელმისაწვდომი",
          "Remove": "წაშლა"
        }
      },
      ua: {
        translation: EN_TRANSLATIONS
      },
    },
    lng: "fr", // if you're using a language detector, do not define the lng option
    fallbackLng: "en",

    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  });
 


function App() {

  const { t } = useTranslation();


  const currencyChange = useRef(false);

  const menuEmail = useRef(null);
  const onButtonClick = () => {
    alert(menuEmail.current);
    if (menuEmail.current)menuEmail.current.click();
  };

  const [language, setLanguage] = useState('fr');
  const [currency, setCurrency] = useState('€');
  const [prices, setPrices] = useState(PRICE_TABLE['€']);

  useEffect(() => {
    const host = window.location.hostname;
    if (host.endsWith('co.uk')) {
      setLanguage('en');
      i18n.changeLanguage('en');
      setCurrency('£');
      setPrices(PRICE_TABLE['£']);
    } else if (host.endsWith('.fr') || host.endsWith('.co')) {
      setLanguage('fr');
      i18n.changeLanguage('fr');
      setCurrency('€');
      setPrices(PRICE_TABLE['€']);
    } else if (host.endsWith('.ge')) {
      setLanguage('ge');
      i18n.changeLanguage('ge');
      setCurrency('₾');
      setPrices(PRICE_TABLE['₾']);
    } else if (host.endsWith('.ua')) {
      setLanguage('ua');
      i18n.changeLanguage('ua');
      setCurrency('€');
      setPrices(PRICE_TABLE['€']);
    }
  }, []);

    const panierVide = useRef({
        amount: 0,
        byCat: {
          domain: {
            amount: 0,
            product_id: null,
            value: ''
          },
          email: {
            amount: 0,
            nbre:0,
            product_id: null,
          },
          website: {
            amount: 0,
            product_id: null,
          },
          mobileapp:  {
            amount: 0,
            product_id: null,
          },
        }
      });

    const [panier, setPanier] = useState(panierVide.current);





  const [domainSearch, setDomainSearch] = useState('');
  const [domainPrincipal, setDomainPrincipal] = useState('');
  const [domainAvailableCheck, setDomainAvailableCheck] = useState('');
  const [nbreEmail, setNbreEmail] = useState(0);
  const [websiteAmount, setWebsiteAmount] = useState(0);
  const [mobileappAmount, setMobileappAmount] = useState(0);
  const [emailType, setEmailType] = useState('workspace');


  const handleOnclick=(e)=>{
    e.preventDefault();
    let lang = e.currentTarget.getAttribute('data-lang');
    setLanguage(lang);
    i18n.changeLanguage(lang);
    if (lang==='fr'){
      setCurrency('€');
      changeCurrency('€');
    } else if (lang==='en'){
      setCurrency('£');
      changeCurrency('£');
    } else if (lang==='ge'){
      setCurrency('₾');
      changeCurrency('₾');
    } else if (lang==='ua'){
      setCurrency('€');
      changeCurrency('€');
    }
  }
 
  const handleCurrencyOnclick=(e)=>{
    e.preventDefault();
    let currency = e.currentTarget.getAttribute('data-currency');
    currencyChange.current = 1;
    setCurrency(currency);
    changeCurrency(currency);
  }

/*
Site Pro : 2490€ / 2790$ / 2090 £
Site Premium : 4990€ / 5590$ / 4290£

Appli Pro : inchangé
Appli Premium : 6990€ / 7890$ / 5990£
*/
  const changeCurrency=(currency_target)=>{

    // window.confirm removed to avoid "Votre panier sera vidé ?" alert
    console.log('changeCurrency => '+currency_target);
    const prices = PRICE_TABLE[currency_target];
    if (prices) {
      setPrices(prices);
    }

    

    // Maj produits sensibles aux devises
    /*
      setTimeout(() => {      
        handleEmail();
        handleWebsite();
      },1000);
    */
    
  }


  const handleEmail=(e)=>{

    var emailVal = document.getElementById('email-form').value;
    
    setNbreEmail(emailVal);

    if (emailType=='redirect')panier.byCat.email.amount = emailVal*2;
    else if (emailType=='pop')panier.byCat.email.amount = emailVal*4;
    else if (emailType=='workspace')panier.byCat.email.amount = emailVal*6;
    else panier.byCat.email.amount = emailVal*0;
    
    setPanier(parseFloat(panier));

    majPanier();

  }


  const handleEmailType=(e)=>{

    var emailTypeVal = e.target.value.toLowerCase().replace(/[^a-zA-Z0-9-]/g,'');
    setEmailType(emailTypeVal);



    if (emailTypeVal=='redirect')panier.byCat.email.amount = nbreEmail*2;
    else if (emailTypeVal=='pop')panier.byCat.email.amount = nbreEmail*4;
    else if (emailTypeVal=='workspace')panier.byCat.email.amount = nbreEmail*6;
    else panier.byCat.email.amount = nbreEmail*0;
    
    setPanier(panier);

    majPanier();

  }

  


  const handleWebsite=(e)=>{
    
    var websiteVal = document.getElementById('others-moving-form-service').value;
    
    
    if (websiteVal=='visitcard')
      panier.byCat.website.amount = prices.visitcard.monthly;
    else if (websiteVal=='professional')
      panier.byCat.website.amount = prices.professional.website.monthly;
    else if (websiteVal=='premium')
      panier.byCat.website.amount = prices.premium.website.monthly;
    else
      panier.byCat.website.amount = 0;

    setWebsiteAmount(panier.byCat.website.amount);

    
    setPanier(panier);
    //console.log(panier);
    //console.log({...panier, 'byCat': {...panier.byCat,'website':{'amount':1234}} });
    //setPanier({...panier, 'byCat': {...panier.byCat,'website':{'amount':1234}} });

    majPanier();
  }


  const handleMobileapp=(e)=>{
    
    var mobileappVal = document.getElementById('form-mobileapp').value;
    
    if (mobileappVal=='professional')
      panier.byCat.mobileapp.amount = prices.professional.mobileapp.monthly;
    else if (mobileappVal=='premium')
      panier.byCat.mobileapp.amount = prices.premium.mobileapp.monthly;
    else
      panier.byCat.mobileapp.amount = 0;

    setMobileappAmount(panier.byCat.mobileapp.amount);

    
    setPanier(panier);

    majPanier();
  }


  const handleDomainSearch=(e)=>{

    var tempoDom = e.target.value.toLowerCase().replace(/[^a-zA-Z0-9-]/g,'');
    setDomainSearch(tempoDom);
    setDomainPrincipal(tempoDom+'.'+document.getElementById('domain-form-search-extension').value);
  }

  const handleDomainExtensionSearch=(e)=>{
    setDomainPrincipal(domainSearch+'.'+e.target.value.toLowerCase());
  }

  const handleDomainSearchIfAvailable =(e)=>{
    e.preventDefault();

    if (domainSearch){
      setDomainAvailableCheck(1);
      

      setTimeout(() => {

        panier.byCat.domain.amount = 1;
        panier.byCat.domain.value = domainPrincipal;
        setPanier(panier);

        majPanier();

        setDomainAvailableCheck(0); // à remplacer par l'ajax      
      }, 2000);

    }
    
  }

  function majPanier(){
    var total = 0;
    //console.log(panier.byCat);

    total+= parseFloat(panier.byCat['domain'].amount);
    total+= parseFloat(panier.byCat['email'].amount);
    total+= parseFloat(panier.byCat['website'].amount);
    total+= parseFloat(panier.byCat['mobileapp'].amount);

    panier.amount = total;

    setPanier(panier);
  }

  function CurrentLang() {

    const flagMap = { ge: "geo" };
    let flag = flagMap[language] || language;
    let imgSrc = "demos/seo/images/flags/" + flag + ".png";
    return (
      <>
      <a href="#"><img src={imgSrc} alt="Lang" />{language.toUpperCase()}</a>
      </>
    );
  };

  function CurrentCurrency() {

    return (
      <>
      <a href="#">{t('Currency')} : {currency}</a>
      </>
    );
    
  };


  function handleDomainRemove() {

    setDomainPrincipal('');


    panier.byCat.domain.amount = 0;
    panier.byCat.domain.value = '';
    setPanier(panier);

    //majPanier();
    
  };




  function DomainSearchIfAvailableBlock() {

    if (domainAvailableCheck){
      return (
        <button type="submit" name="home-moving-form-submit" class="btn bg-success text-white fw-medium w-100 py-2 mt-2" style={{
  backgroundColor: '#FF4863 !important'}}>Vérification en cours {domainPrincipal != ''? ' de « '+domainPrincipal+' »': ''}</button>
      );
    }else{
      return (
        <button type="submit" onClick={handleDomainSearchIfAvailable} name="home-moving-form-submit" class="btn bg-color text-white fw-medium w-100 py-2 mt-2" style={{
  backgroundColor: '#FF4863 !important'}}>Vérifier la disponibilité{domainPrincipal != ''? ' de « '+domainPrincipal+' »': ''}</button>
      );
    }
    
  };


  function AmountTab(props) {

    if (props.amount>0)
      return (
        <>
        &nbsp;&#183; <small style={{fontSize:'0.8em'}}>{props.amount} {currency}</small>
        </>
      );
    else return null;
    
  };

  function BoutonCommanderBlock(props) {

    return (
      <>
      <a href={contactHref} className="button button-rounded ms-3 d-none d-sm-block hidden-important">{t('Commander')} &#183; {props.amount} {currency}</a>
      </>
    );
    
  };

  function DomainSelectedBlock(props){

    if (panier.byCat.domain.value){
    return (
      <>
      <table class="table w-100" style={{fontSize:'0.9em'}}>
          <thead class="thead-dark">
            <tr>
            <td scope="col">Domaine</td>
            <td scope="col">Statut</td>
            <td scope="col">Prix</td>
            <td scope="col">Action</td>
            </tr>
          </thead>
        <tbody>
          <tr>
            <td scope="row"><strong class="text-success">{panier.byCat.domain.value?panier.byCat.domain.value:''}</strong></td>
            <td>{t('AVAILABLE')}</td>
            <td>{panier.byCat.domain.value?panier.byCat.domain.amount:''} {currency} / {t('month')}</td>
            <td onClick={handleDomainRemove}><small class="btn btn-outline-info btn-sm" role="button">{t('Remove')}</small></td>
          </tr>
        </tbody>
      </table>
      <form><div class="col-sm-12 form-group">
      
      <div class="row">
        <div class="col-6"><button name="office-moving-form-submit2" class="btn bg-success text-white fw-medium w-100 py-2 mt-2">Total &#183; {panier.amount} {currency}</button></div>
        <div class="col-6"><button type="submit" name="office-moving-form-submit" class="btn bg-dark text-white fw-medium w-100 py-2 mt-2">Email →</button></div>
      </div>
      </div>
      </form>
      <hr />
      </>
    );
    }else{
      return(
      <></>
      );
    }
  }


  function SliderBlock() {

    //alert('currencyChange');
    //alert(currencyChange.current);
    //alert(language);

    //if (currencyChange.current){
      setTimeout(() => {
        window.SEMICOLON.widget.textRotator();
      }, 100);
    //}

    return (
      <>
      <div className="slider_fr">
        <h2 className="text-rotater mb-2" data-rotate="fadeIn" data-speed="3500">{t('We\'re building your')} <span className="t-rotate">{t('Mobile Application')},{t('Website')}</span></h2>
        <h3 className="text-rotater mb-2" data-separator="," data-rotate="fadeIn" data-speed="3500">- <span className="t-rotate" style={{color: 'inherit'}}>{t('Your mobile app on')},{t('Your')}</span> <span className="t-rotate">iOS & Android,{t('responsive')}</span> <span className="t-rotate" style={{color: 'inherit'}}>,{t('WebsiteOnlyInEnglish')}</span> {t('from')} <span className="t-rotate" style={{color: 'inherit'}}>{prices.professional.mobileapp.oneshot},{prices.professional.website.oneshot}</span> {currency}</h3>
        <p>
        <Trans
          i18nKey="Choose" // optional -> fallbacks to defaults if not provided
          defaults="..." // optional defaultValue
          values={{ arg1: '...',arg2: '...'}}
          components={{ italic: <i />, bold: <strong /> }}
        />
        </p>
      </div>
      </>
    );
    
  };

  const langSuffix = language === 'fr' ? '' : (language === 'en' ? '.en' : (language === 'ge' ? '.ge' : (language === 'ua' ? '.ua' : '')));
  const contactHref = `contact${langSuffix}.html`;
  const termsHref = `terms${langSuffix}.html`;
  const privacyHref = `privacy${langSuffix}.html`;

  return (
    <>
  <div id="wrapper" className="clearfix">

    <div id="top-bar" className="transparent-topbar">
      <div className="container clearfix">

        <div className="row justify-content-between">
          <div className="col-12 col-md-auto">

            <div className="top-links">
              <ul className="top-links-container">
               <li className="top-links-item"><CurrentLang />
                  <ul className="top-links-sub-menu">
                    <li className="top-links-item"><a data-lang="en" onClick={handleOnclick}><img src="demos/seo/images/flags/en.png" alt="Lang" />EN</a></li>
                    <li className="top-links-item"><a data-lang="fr" onClick={handleOnclick}><img src="demos/seo/images/flags/fr.png" alt="Lang" />FR</a></li>
                    <li className="top-links-item"><a data-lang="ge" onClick={handleOnclick}><img src="demos/seo/images/flags/geo.png" alt="Lang" />GE</a></li>
                    <li className="top-links-item"><a data-lang="ua" onClick={handleOnclick}><img src="demos/seo/images/flags/ua.png" alt="Lang" />UA</a></li>
                  </ul>
                </li>
                <li className="top-links-item"><CurrentCurrency />
                  <ul className="top-links-sub-menu">
                    <li className="top-links-item"><a data-currency="£" onClick={handleCurrencyOnclick}>£</a></li>
                    <li className="top-links-item"><a data-currency="€" onClick={handleCurrencyOnclick}>€</a></li>
                    <li className="top-links-item"><a data-currency="$" onClick={handleCurrencyOnclick}>$</a></li>
                    <li className="top-links-item"><a data-currency="₾" onClick={handleCurrencyOnclick}>₾</a></li>
                  </ul>
                </li>
              </ul>
            </div>

          </div>

          <div className="col-12 col-md-auto dark">

            <ul id="top-social">
              <li><a href="https://facebook.com/mafate.co" className="si-facebook" target="_blank"><span className="ts-icon"><i className="icon-facebook"></i></span><span className="ts-text">Facebook</span></a></li>
              <li><a href="https://instagram.com/mafate.co" className="si-instagram" target="_blank"><span className="ts-icon"><i className="icon-instagram2"></i></span><span className="ts-text">Instagram</span></a></li>
              {/*<li><a href="https://twitter.com/mafate.co" className="si-twitter" target="_blank"><span className="ts-icon"><i className="icon-twitter"></i></span><span className="ts-text">Twitter</span></a></li>
              <li><a href="https://www.youtube.com/channel/UCwOlFlxe-2-CrBdGYVVsyNQ" className="si-youtube" target="_blank"><span className="ts-icon"><i className="icon-youtube"></i></span><span className="ts-text">Youtube</span></a></li>
              <li><a href="tel:+33XXXXXXXXX" className="si-call"><span className="ts-icon"><i className="icon-call"></i></span><span className="ts-text">+33 (0)X XX XX XX XX</span></a></li>
              */}
              <li><a href={`mailto:${t('hello@mafate.co')}`} className="si-email3"><span className="ts-icon"><i className="icon-envelope-alt"></i></span><span className="ts-text">{t('hello@mafate.co')}</span></a></li>
            </ul>

          </div>
        </div>

      </div>
    </div>

    
    <header id="header" className="transparent-header floating-header header-size-md">
      <div id="header-wrap">
        <div className="container">
          <div className="header-row">

            <div id="logo">
              <a href="index.html" className="standard-logo" data-dark-logo="images/logoMafate1500px.png"><img src="images/logoMafateSmall.png" alt="Mafate Logo" /></a>
              <a href="index.html" className="retina-logo" data-dark-logo="images/logoMafateSmall.png"><img src="images/logoMafateSmall.png" alt="Mafate Logo" /></a>
            </div>

            <div className="header-misc">

              <a href={contactHref} className="button button-rounded ms-3 d-none d-sm-block">{t('Schedule Appointments')}</a>
              <BoutonCommanderBlock amount={panier.amount}/>

            </div>

            <div id="primary-menu-trigger">
              <svg className="svg-trigger" viewBox="0 0 100 100"><path d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20"></path><path d="m 30,50 h 40"></path><path d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20"></path></svg>
            </div>

            <nav className="primary-menu with-arrows">

              <ul className="menu-container">
                <li className="menu-item current"><a className="menu-link" href="demo-seo.html"><div>{t('Home')}</div></a></li>
                <li className="menu-item"><a className="menu-link" href="#services"><div>{t('Services')}</div></a></li>
                <li className="menu-item"><a className="menu-link" href="#pricing"><div>{t('Pricing')}</div></a></li>
                <li className="menu-item"><a className="menu-link" href={contactHref}><div>{t('Contact Us')}</div></a></li>
              </ul>

            </nav>
            
          </div>
        </div>
      </div>
      <div className="header-wrap-clone"></div>
    </header>
    


    <section id="slider" className="slider-element slider-parallax min-vh-60 min-vh-md-100 min-vh-sm-40 include-header">
      <div className="slider-inner" style={{background: '#FFF url(demos/seo/images/hero/hero-1.jpg) center center no-repeat', backgroundSize: 'cover'}}>

        <div className="vertical-middle slider-element-fade">
          <div className="container py-5 pt-sm-0">
            <div className="row pt-5 pt-sm-0">

              <div className="col-lg-5 col-md-8">
                <div className="slider-title">

                  <div className="badge rounded-pill badge-default">MAFATE.CO</div>
                  <SliderBlock />

                  <a href="#pricing" className="button button-rounded button-large nott ls0">{t('Pricing')}</a>
                  <a href={contactHref} className="button button-rounded button-large button-light text-dark bg-white border nott ls0">{t('Free Online Appointment')}</a>
                </div>
              </div>

              
<div class="col-lg-7 d-none">
                <ul class="ongletprix nav nav-tabs nav-justified flex-column border-bottom-0 flex-md-row bg-color mt-4" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link py-3 active" id="home-moving-tab" data-bs-toggle="tab" href="#home-moving" role="tab" aria-controls="home-moving" aria-selected="true">{t('Domain')}<AmountTab amount={panier.byCat.domain.amount}/></a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link py-3" id="office-moving-tab" data-bs-toggle="tab" href="#office-moving" role="tab" aria-controls="office-moving" aria-selected="false">Emails<AmountTab amount={panier.byCat.email.amount}/></a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link py-3" id="siteweb-tab" data-bs-toggle="tab" href="#tab-siteweb" role="tab" aria-controls="tab-siteweb" aria-selected="false">Site Web<AmountTab amount={panier.byCat.website.amount}/></a>
                  </li><li class="nav-item">
                    <a class="nav-link py-3" id="others-moving-tab" data-bs-toggle="tab" href="#others-moving" role="tab" aria-controls="others-moving" aria-selected="false">Appli. Mobile<AmountTab amount={panier.byCat.mobileapp.amount}/></a>
                  </li>
                </ul>
                <div class="tab-content rounded-bottom shadow bg-white py-4 px-5">
                  <div class="tab-pane fade active show" id="home-moving" role="tabpanel" aria-labelledby="home-moving-tab">
                    
                    
                    <DomainSelectedBlock />

                    <p class="mb-4">{panier.byCat.domain.value?'Ajouter un autre domaine':'Vérifiez la disponibilité de votre nom de domaine'} :</p>
                    <div class="form-widget">
                      <div class="form-result"></div>
                      <form class="row home-moving-form position-relative mb-0" action="include/form.php" method="post" enctype="multipart/form-data" novalidate="novalidate">
                        



                        <div class="form-process">
                          <div class="css3-spinner">
                            <div class="css3-spinner-scaler"></div>
                          </div>
                        </div>


                        

                        <div class="col-sm-8 form-group">
                          <div class="input-group">
                            
                            <input key="domain-form-search" type="text" name="domain-form-search" id="domain-form-search" class="form-control required" placeholder="domaine"  value={domainSearch} onChange={handleDomainSearch} />
                          </div>
                        </div>



                        <div class="col-sm-4 form-group"><div class="input-group">
                            
                            <select class="required form-select" name="domain-form-search-extension" id="domain-form-search-extension" onChange={handleDomainExtensionSearch}>
                              <option value="re">.re</option>
                              <option value="fr">.fr</option>
                              <option value="com">.com</option>
                              <option value="yt">.yt</option>
                              <option value="mu">.mu</option>
                              <option value="gp">.gp</option>
                              <option value="mq">.mq</option></select>
                          </div>
                        </div>

                        

                        

                        

                        

                        <div class="col-12 d-none">
                          <input type="text" id="home-moving-form-botcheck" name="home-moving-form-botcheck" value="" />
                        </div>

                        <div class="col-12">
                          <DomainSearchIfAvailableBlock />
                        </div>
                        
                        <input type="hidden" name="prefix" value="home-moving-form-" />
                        <input type="hidden" name="subject" value="Home Moving Request" />
                        <input type="hidden" name="html_title" value="Home Moving" />
                      </form>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="office-moving" role="tabpanel" aria-labelledby="office-moving-tab">
                    <p class="mb-4">Obtenez des emails professionels {panier.byCat.domain.value == ''? '': 'de type nom.prenom@'+panier.byCat.domain.value }</p>
                    <div class="form-widget">
                      <div class="form-result"></div>
                      <form class="row office-moving-form position-relative mb-0" action="include/form.php" method="post" enctype="multipart/form-data" novalidate="novalidate">
                        <div class="form-process">
                          <div class="css3-spinner">
                            <div class="css3-spinner-scaler"></div>
                          </div>
                        </div>

                        <div class="col-sm-12 form-group">


                                <div className="radio">
                                  <label>
                                    <input type="radio" value="redirect" onClick={handleEmailType} checked={emailType==='redirect'} />
                                    &nbsp; Redirection
                                  </label>
                                </div>
                                <div className="radio">
                                  <label>
                                    <input type="radio" value="pop" onClick={handleEmailType} checked={emailType==='pop'} />
                                    &nbsp; POP / SMTP / IMAP
                                  </label>
                                </div>
                                <div className="radio">
                                  <label>
                                    <input type="radio" value="workspace" onClick={handleEmailType} checked={emailType==='workspace'} />
                                    &nbsp; Google Workspace (Gmail)
                                  </label>
                                </div>

                        </div>

                        <div class="col-sm-12 form-group">
                          <div class="input-group">
                            <span class="input-group-text text-muted bg-transparent"><i class="icon-line2-envelope"></i></span>
                            <select class="required form-select" name="email-form" id="email-form" onChange={handleEmail}>
                              <option value="" disabled="" selected="">-- Nombre d'adresses emails ? --</option>
                              <option key="email-1" value="1">1 adresse email</option>
                              <option key="email-2" value="2">2 adresses</option>
                              <option key="email-3" value="3">3 adresses</option>
                              <option key="email-4" value="4">4 adresses</option>
                              <option key="email-5" value="5">5 adresses</option>
                              <option key="email-6" value="6">6 adresses</option>
                              <option key="email-7" value="7">7 adresses</option>
                              <option key="email-8" value="8">8 adresses</option>
                              <option key="email-9" value="9">9 adresses</option>
                              <option key="email-10" value="10">10 adresses</option>
                              <option key="email-11" value="11">11 adresses</option>
                              <option key="email-12" value="12">12 adresses</option>
                              <option key="email-13" value="13">13 adresses</option>
                              <option key="email-14" value="14">14 adresses</option>
                              <option key="email-15" value="15">15 adresses</option>
                              <option key="email-16" value="16">16 adresses</option>
                              <option key="email-17" value="17">17 adresses</option>
                              <option key="email-18" value="18">18 adresses</option>
                              <option key="email-19" value="19">19 adresses</option>
                              <option key="email-20" value="20">20 adresses</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-12 d-none">
                          <input type="text" id="office-moving-form-botcheck" name="office-moving-form-botcheck" value="" />
                        </div>

                        <div class="col-6">
                          <button type="submit" name="office-moving-form-submit" class="btn bg-color text-white fw-medium w-100 py-2 mt-2">Total &#183; {panier.amount} {currency}</button>
                        </div>
                        <div class="col-6">
                          <button type="submit" name="office-moving-form-submit" class="btn bg-dark text-white fw-medium w-100 py-2 mt-2">Site Internet &#8594;</button>
                        </div>

                        <input type="hidden" name="prefix" value="office-moving-form-" />
                        <input type="hidden" name="subject" value="Office Moving Request" />
                        <input type="hidden" name="html_title" value="Office Moving" />
                      </form>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="tab-siteweb" role="tabpanel" aria-labelledby="office-moving-tab">
                    <p class="mb-4">Choisissez la complexité de votre site internet pour ajuster votre devis</p>
                    <div class="form-widget">
                      <div class="form-result"></div>
                      <form class="row office-moving-form position-relative mb-0" action="include/form.php" method="post" enctype="multipart/form-data" novalidate="novalidate">
                        <div class="form-process">
                          <div class="css3-spinner">
                            <div class="css3-spinner-scaler"></div>
                          </div>
                        </div>


                        <div class="col-12 form-group">
                          <div class="input-group">
                            <span class="input-group-text bg-transparent"><i class=" icon-line2-globe"></i></span>
                            <select class="required form-select" name="others-moving-form-service" id="others-moving-form-service" onChange={handleWebsite}>
                              <option key="website_0" value="" disabled="" selected="">-- Complexité de votre site ? --</option>
                              <option key="website_1" value="visitcard">Site "Carte de visite" &#183; {prices.visitcard.monthly} {currency} / {t('month')}</option>
                              <option key="website_2" value="professional">Site Pro &#183; {prices.professional.website.oneshot} {currency} puis {prices.professional.website.monthly} {currency} / {t('month')}</option>
                              <option key="website_3" value="premium">Site Premium &#183; {prices.premium.website.oneshot} {currency} puis {prices.premium.website.monthly} {currency} / {t('month')}</option>
                              <option key="website_4" value="Sur Mesure">Sur-mesure</option>
                            </select>
                          </div>
                        </div>
                        


                        <div class="col-12 d-none">
                          <input type="text" id="office-moving-form-botcheck" name="office-moving-form-botcheck" value="" />
                        </div>

                        <div class="col-6">
                          <button type="submit" name="office-moving-form-submit" class="btn bg-color text-white fw-medium w-100 py-2 mt-2">Total &#183; {panier.amount} {currency}</button>
                        </div>
                        <div class="col-6">
                          <button type="submit" name="office-moving-form-submit" class="btn bg-dark text-white fw-medium w-100 py-2 mt-2">{t('Mobile Application')} &#8594;</button>
                        </div>

                        <input type="hidden" name="prefix" value="office-moving-form-" />
                        <input type="hidden" name="subject" value="Office Moving Request" />
                        <input type="hidden" name="html_title" value="Office Moving" />
                      </form>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="others-moving" role="tabpanel" aria-labelledby="others-moving-tab">
                    <div class="form-widget">
                      <div class="form-result"></div>
                      <form class="row others-moving-form position-relative mb-0" action="include/form.php" method="post" enctype="multipart/form-data" novalidate="novalidate">
                        <div class="form-process">
                          <div class="css3-spinner">
                            <div class="css3-spinner-scaler"></div>
                          </div>
                        </div>

                        <div class="col-12 form-group">
                          <div class="input-group">
                            <span class="input-group-text bg-transparent"><i class=" icon-line2-globe"></i></span>
                            <select class="required form-select" name="form-mobileapp" id="form-mobileapp" onChange={handleMobileapp}>
                              <option key="mobileapp_0" value="" disabled="" selected="">-- Complexité de votre application mobile ? --</option>
                              <option key="mobileapp_1" value="professional">Application Pro &#183; {prices.professional.mobileapp.oneshot} {currency} puis {prices.professional.mobileapp.monthly} {currency} / {t('month')}</option>
                              <option key="mobileapp_2" value="premium">Application Premium &#183; {prices.premium.mobileapp.oneshot} {currency} puis {prices.professional.mobileapp.monthly} {currency} / {t('month')}</option>
                              <option key="mobileapp_3" value="sur-mesure">Sur-mesure</option>
                            </select>
                          </div>
                        </div>

                        {/*
                        <div class="col-sm-6 form-group">
                          <div class="input-group">
                            <span class="input-group-text bg-transparent"><i class="icon-line2-social-dropbox"></i></span>
                            <input type="text" name="others-moving-form-item" id="others-moving-form-item" class="form-control required" value="" placeholder="Your Item" />
                          </div>
                        </div>

                        <div class="col-sm-6 form-group">
                          <div class="input-group">
                            <span class="input-group-text text-muted bg-transparent"><i class="icon-user-circle1"></i></span>
                            <select class="required form-select" name="others-moving-form-movers" id="others-moving-form-movers">
                              <option value="" disabled="" selected="">-- Select Movers --</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-sm-6 form-group">
                          <div class="input-group">
                            <span class="input-group-text bg-transparent"><i class="icon-truck1"></i></span>
                            <input type="text" name="others-moving-form-location-from" id="others-moving-form-location-from" class="form-control required" value="" placeholder="Location From" />
                          </div>
                        </div>

                        <div class="col-sm-6 form-group">
                          <div class="input-group">
                            <span class="input-group-text bg-transparent"><i class="icon-line2-map"></i></span>
                            <input type="text" name="others-moving-form-location-to" id="others-moving-form-location-to" class="form-control required" value="" placeholder="Location To" />
                          </div>
                        </div>
                      */}

                        <div class="col-12 d-none">
                          <input type="text" id="others-moving-form-botcheck" name="others-moving-form-botcheck" value="" />
                        </div>

                        
                        <div class="col-12">
                          <button type="submit" name="office-moving-form-submit" class="btn bg-color text-white fw-medium w-100 py-2 mt-2">Total &#183; {panier.amount} {currency}</button>
                        </div>


                        <input type="hidden" name="prefix" value="others-moving-form-" />
                        <input type="hidden" name="subject" value="Others Service Request" />
                        <input type="hidden" name="html_title" value="Others Service" />
                      </form>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>

        </div>

        <div className="video-wrap h-100 d-block d-lg-none">
          <div className="video-overlay" style={{background: 'rgba(255,255,255,0.85)'}}></div>
        </div>

      </div>
    </section>

    <section id="content">

      <div className="content-wrap pt-0 pb-0">

        
        <div id="services" className="section bg-transparent mt-4 mb-0 pb-0 pb-sm-5 pt-sm-5 mt-sm-0">
          <div className="container">
            <div className="heading-block border-bottom-0 center mx-auto mb-0" style={{maxWidth: '550px'}}>
              <div className="badge rounded-pill badge-default">{t('Services')}</div>
              <h3 className="nott ls0 mb-3">{t('Our Services')}</h3>
              <p>{t('ServicesBlockLine1')}</p>
            </div>
            <div className="row justify-content-between align-items-center">

              <div className="col-lg-4 col-sm-6">

                <div className="feature-box flex-md-row-reverse text-md-end border-0">
                  <div className="fbox-icon">
                    <a href="#"><img src="demos/seo/images/icons/seo.svg" alt="Feature Icon" className="bg-transparent rounded-0" /></a>
                  </div>
                  <div className="fbox-content">
                    <h3 className="nott ls0">{t('Domain Name')}</h3>
                    <p>{t('We are booking your domain')}.</p>
                  </div>
                </div>

                <div className="feature-box flex-md-row-reverse text-md-end border-0 mt-5">
                  <div className="fbox-icon">
                    <a href="#"><img src="demos/seo/images/icons/group.svg" alt="Feature Icon" className="bg-transparent rounded-0" /></a>
                  </div>
                  <div className="fbox-content">
                    <h3 className="nott ls0">{t('Email Account')}</h3>
                    <p>{t('Your professional emails like xyz@mycompany.com')}</p>
                  </div>
                </div>

              </div>

              <div className="col-lg-3 col-7 offset-3 offset-sm-0 d-sm-none d-lg-block center my-5 d-none d-lg-block">
                <img src="demos/seo/images/sections/2.png" alt="iphone" className="rounded  parallax" data-bottom-top="transform: translateY(-30px)" data-top-bottom="transform: translateY(30px)" />
              </div>

              <div className="col-lg-4 col-sm-6">

                <div className="feature-box border-0">
                  <div className="fbox-icon">
                    <a href="#"><img src="demos/seo/images/icons/social.svg" alt="Feature Icon" className="bg-transparent rounded-0" /></a>
                  </div>
                  <div className="fbox-content">
                    <h3 className="nott ls0">{t('Mobile Application')}</h3>
                    <p>{t('Your iOS & Android mobile application')}</p>
                  </div>
                </div>

                <div className="feature-box border-0 mt-5">
                  <div className="fbox-icon">
                    <a href="#"><img src="demos/seo/images/icons/globe.svg" alt="Feature Icon" className="bg-transparent rounded-0" /></a>
                  </div>
                  <div className="fbox-content">
                    <h3 className="nott ls0">{t('Website')}</h3>
                    <p>{t('Your personnalised website')}</p>
                  </div>
                </div>


              </div>

            </div>
          </div>
        </div>

        <div id="pricing" className="section m-0 pb-sm-5 pt-sm-5" style={{background: 'url(demos/seo/images/sections/4.png) no-repeat center top', backgroundSize: 'cover', padding: '140px 0 0'}}>
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-lg-12">
                <div className="heading-block border-bottom-0 bottommargin-sm">
                  <div className="badge rounded-pill badge-default">{t('Pricing')}</div>
                  <h3 className="nott ls0">{t('PricingBlockTitle')}</h3>
                </div>
                <p>{t('PricingBlockLine1')}<br />{t('PricingBlockLine2')}</p>
              </div>
                <div className="w-100"></div>
                <div className="pricing-tenure-switcher d-flex align-items-center mb-4 mb-sm-0 position-relative" data-container="#pricing-switch">
                <div className="col-5 col-lg-6" style={{textAlign:'right'}}>
                    <span className="pts-left fw-bold text-muted">Professional</span>
                </div>
                <div className="col-2 col-lg-1">
                    <div className="pts-switcher mx-3" style={{width: '60px', marginRight: 'auto !important', marginLeft: 'auto !important'}}>
                      <div className="switch">
                        <input id="switch-toggle-pricing-tenure" className="switch-toggle switch-toggle-round" type="checkbox" />
                        <label htmlFor="switch-toggle-pricing-tenure" className="mb-0"></label>
                      </div>
                    </div>
                </div>
                <div className="col-5">
                    <span className="pts-right fw-bold text-muted">Premium</span>
                </div>
              </div>

              <div className="col-lg-12">
                <div id="section-pricing" className="page-section p-0 m-0">

                  <div id="pricing-switch" className="pricing row align-items-end g-0 col-mb-50 mb-4">

                    <div className="col-md-6 offset-md-0 col-sm-12 pb-sm-0">

                      <div className="pricing-box m-3">
                        <div className="pricing-title">
                          <img className="mb-2 bg-transparent rounded-0" src="demos/seo/images/icons/globe.svg" alt="Pricing Icon" width="50" />
                          <h3>{t('Website')} <span className="pts-switch-content-right d-inline"><span className="badge badge-primary badge-premium">PREMIUM</span></span></h3>
                          <span>Responsive</span>
                        </div>
                        <div className="pricing-price">
                          <div className="pts-switch-content-left"><span className="">{prices.professional.website.oneshot}</span><span className="price-unit">{currency} HT</span><span className="price-tenure">{t('then')} {prices.professional.website.monthly}{currency} / {t('month')}</span></div>
                          <div className="pts-switch-content-right">{prices.premium.website.oneshot}<span className="price-unit">{currency} HT</span><span className="price-tenure">{t('then')} {prices.premium.website.monthly}{currency} / {t('month')}</span></div>
                        </div>
                        <div className="pricing-features border-0 bg-transparent">
                          <ul>
                          
                            <li className="pts-switch-content-left"><i className="icon-check-circle color me-2"></i><Trans
                            i18nKey="Personnalisation_template" // optional -> fallbacks to defaults if not provided
                            defaults="..." // optional defaultValue
                            values={{ arg1: '...',arg2: '...'}}
                            components={{ italic: <i />, bold: <strong /> }}
                          /></li>
                            <li className="pts-switch-content-right"><i className="icon-check-circle color me-2"></i><span className="badge badge-primary badge-premium">PREMIUM</span> <Trans
                            i18nKey="Personnalisation_premium" // optional -> fallbacks to defaults if not provided
                            defaults="..." // optional defaultValue
                            values={{ arg1: '...',arg2: '...'}}
                            components={{ italic: <i />, bold: <strong /> }}
                          />
                            </li>
                            <li><i className="icon-check-circle color me-2"></i>{t('Hosting')} & <strong>{t('Domain Name')}</strong> {t('included')}</li>
                            <li><i className="icon-check-circle color me-2"></i>{t('Easy to use')}<strong>{t('Administration Panel')}</strong>{t('simple d\'utilisation')}</li>
                            <li><i className="icon-check-circle color me-2"></i><strong>API</strong> {t('access included in the monthly subscription')}</li>
                            <li><i className="icon-check-circle color me-2"></i><strong>1 {t('email account')}</strong> Google Workspace</li>
                            <li className="pts-switch-content-right"><i className="icon-check-circle color me-2"></i><span className="badge badge-primary badge-premium">PREMIUM</span> <Trans
                            i18nKey="multilingual_line"
                            defaults="..."
                            values={{ arg1: '...',arg2: '...'}}
                            components={{ italic: <i />, bold: <strong /> }}
                          /></li>
                            <li><i className="icon-check-circle color me-2"></i>{t('Up to')} <strong>5 modules</strong> <em><small>({t('modules_liste_onpricingblock')})</small></em></li>
                            <li><i className="icon-check-circle color me-2"></i>{t('Cookies management')} <strong>{t('GDPR Compliant')}</strong></li>
                            <li className="pts-switch-content-right"><i className="icon-check-circle color me-2"></i><span className="badge badge-primary badge-premium">PREMIUM</span> <Trans
                            i18nKey="User authentification"
                            defaults="..."
                            values={{ arg1: '...',arg2: '...'}}
                            components={{ italic: <i />, bold: <strong /> }}
                          /> : SMS / Facebook / Google</li>
                          <li><i className="icon-check-circle color me-2"></i>{t('Technology')} : <strong>React JS</strong>, Firebase, Api</li>
                          </ul>
                        </div>
                        <div className="pricing-action">
                          
                        </div>
                      </div>

                    </div>
          
                    <div className="col-md-6 col-sm-12 pb-sm-0">

                      <div className="pricing-box m-3">
                        <div className="pricing-title">
                          <img className="mb-2 bg-transparent rounded-0" src="demos/seo/images/icons/social.svg" alt="Pricing Icon" width="60" />
                          <h3>{t('Mobile Application')} <span className="pts-switch-content-right d-inline"><span className="badge badge-primary badge-premium">PREMIUM</span></span></h3>
                          <span>iOS & Android</span>
                        </div>
                        <div className="pricing-price">
                          <div className="pts-switch-content-left">{prices.professional.mobileapp.oneshot}<span className="price-unit">{currency} HT</span><span className="price-tenure">{t('then')} {prices.professional.mobileapp.monthly}{currency} / {t('month')}</span></div>
                          <div className="pts-switch-content-right">{prices.premium.mobileapp.oneshot}<span className="price-unit">{currency} HT</span><span className="price-tenure">{t('then')} {prices.premium.mobileapp.monthly}{currency} / {t('month')}</span></div>
                        </div>
                        <div className="pricing-features border-0 bg-transparent">
                          <ul>
                            <li className="pts-switch-content-left"><i className="icon-check-circle color me-2"></i><Trans
                            i18nKey="Personnalisation_template" // optional -> fallbacks to defaults if not provided
                            defaults="..." // optional defaultValue
                            values={{ arg1: '...',arg2: '...'}}
                            components={{ italic: <i />, bold: <strong /> }}
                          /></li>
                            <li className="pts-switch-content-right"><i className="icon-check-circle color me-2"></i><span className="badge badge-primary badge-premium">PREMIUM</span> <Trans
                            i18nKey="Personnalisation_premium" // optional -> fallbacks to defaults if not provided
                            defaults="..." // optional defaultValue
                            values={{ arg1: '...',arg2: '...'}}
                            components={{ italic: <i />, bold: <strong /> }}
                          /></li>
                            <li><i className="icon-check-circle color me-2"></i>{t('Easy to use')}<strong>{t('Administration Panel')}</strong>{t('simple d\'utilisation')}</li>
                            <li><i className="icon-check-circle color me-2"></i><strong>API</strong> {t('access included in the monthly subscription')}</li>
                            <li className="pts-switch-content-right"><i className="icon-check-circle color me-2"></i><span className="badge badge-primary badge-premium">PREMIUM</span> <Trans
                            i18nKey="multilingual_line"
                            defaults="..."
                            values={{ arg1: '...',arg2: '...'}}
                            components={{ italic: <i />, bold: <strong /> }}
                          /></li>
                          <li className="pts-switch-content-right"><i className="icon-check-circle color me-2"></i><span className="badge badge-primary badge-premium">PREMIUM</span> <Trans
                            i18nKey=""
                            defaults="10 hours of on-demand development included"
                            values={{ arg1: '...',arg2: '...'}}
                            components={{ italic: <i />, bold: <strong /> }}
                          /></li>
                            <li><i className="icon-check-circle color me-2"></i>{t('Up to')} <strong>5 modules</strong> <em><small>({t('modules_liste_onpricingblock')})</small></em></li>
                            <li><i className="icon-check-circle color me-2"></i><strong>Push</strong> Mobile</li>
                            <li className="pts-switch-content-right"><i className="icon-check-circle color me-2"></i><span className="badge badge-primary badge-premium">PREMIUM</span> <Trans
                            i18nKey="User authentification"
                            defaults="..."
                            values={{ arg1: '...',arg2: '...'}}
                            components={{ italic: <i />, bold: <strong /> }}
                          /> : SMS / Facebook / Google</li>
                          <li><i className="icon-check-circle color me-2"></i>{t('Technology')} : <strong>React Native</strong>, Firebase, Api</li>
                          </ul>
                        </div>
                        <div className="pricing-action">
                          
                        </div>
                      </div>

                    </div>

                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>


        <div id="contact" className="section m-0 pb-sm-5 pt-sm-5" style={{background: 'url(demos/seo/images/sections/1.jpg) no-repeat center center', backgroundSize: 'cover', padding: '100px 0'}}>
          <div className="container">
            <div className="row justify-content-between align-items-center">

              <div className="col-md-4">
                <div className="heading-block border-bottom-0 bottommargin-sm">
                  <div className="badge rounded-pill badge-default">{t('Contact Us')}</div>
                  <h3 className="nott ls0">{t('ContactBlockLine1')}</h3>
                </div>
                <p>{t('ContactBlockLine2')}.</p>

                <div className="widget clearfix mb-4">

                  <div className="row clearfix">
                    <div className="col-12 mb-4">
                      <div className="feature-box fbox-plain fbox-sm align-items-center">
                        <div className="fbox-icon">
                          <i className="icon-envelope text-dark"></i>
                        </div>
                        <div className="fbox-content">
                          
                          <span className="text-muted">Email :</span><br />
                          <h3 className="nott ls0 fw-semibold">{t('hello@mafate.co')}</h3>

                          <span className="text-muted">{t('Address')} :</span><br />
                          <h3 className="nott ls0 fw-semibold">{t('address_value')}</h3>

                          <span className="text-muted">{t('Identification')} :</span><br />
                          <h3 className="nott ls0 fw-semibold">{t('identification_value')}</h3>

                        </div>
                      </div>
                    </div>
                  </div>

                </div>


              </div>

              {/*
              <div className="col-lg-6 col-md-8">
                <div className="card shadow-sm">
                  <div className="card-body">
                    <h4 className="mb-3">{t('Your details')}</h4>
                    <div className="form-widget">
                      <div className="form-result"></div>
                      <form className="row mb-0" id="template-contactform" name="template-contactform" action="include/form.php" method="post">
                        <div className="col-6 form-group mb-3">
                          <label htmlFor="template-contactform-name">{t('Name')}*</label>
                          <input type="text" id="template-contactform-name" name="template-contactform-name" className="form-control input-sm required" value="" />
                        </div>
                        <div className="col-6 form-group mb-3">
                          <label htmlFor="template-contactform-company">{t('Company')}</label>
                          <input type="text" id="template-contactform-company" name="template-contactform-company" className="form-control input-sm" value="" />
                        </div>
                        <div className="col-6 form-group mb-3">
                          <label htmlFor="template-contactform-email">{t('Email')}*</label>
                          <input type="email" id="template-contactform-email" name="template-contactform-email" className="form-control input-sm required" value="" />
                        </div>
                        <div className="col-6 form-group mb-3">
                          <label htmlFor="template-contactform-phone">{t('Phone')}*</label>
                          <input type="email" id="template-contactform-phone" name="template-contactform-phone" className="form-control input-sm required" value="" />
                        </div>
                        <div className="col-12 form-group mb-4">
                          <label htmlFor="template-contactform-message">{t('Your Message')}*</label>
                          <textarea type="text" id="template-contactform-message" name="template-contactform-website" className="form-control input-sm required" value=""></textarea>
                        </div>
                        <div className="col-12 form-group d-none">
                          <input type="text" id="template-contactform-botcheck" name="template-contactform-botcheck" value="" className="sm-form-control" />
                        </div>
                        <div className="col-12 form-group mb-0">
                          <button className="button button-rounded w-100 nott ls0 m-0" type="submit" id="template-contactform-submit" name="template-contactform-submit" value="submit">{t('Send')}</button>
                        </div>
                        <input type="hidden" name="prefix" value="template-contactform-" />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              */}

              <div className="col-lg-6 col-md-8">
                <div className="card shadow-sm">
                  <div className="card-body">
                    <h4 className="mb-3">{t('Booking an online appointment')}</h4>
                    <div className="form-widget">
                      <div className="form-result"></div>
                      <form className="row mb-0" id="template-contactform" name="template-contactform" action="include/form.php" method="post">
                        
                        <div className="col-12 form-group mb-0">


                         <div 
                          className="calendly-inline-widget"
                          data-url="https://calendly.com/mafate/rdv?hide_gdpr_banner=1&primary_color=ffbe49"
                          style={{ minWidth: '320px', height: '700px' }} />

                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>


            </div>

          </div>
        </div>
      </div>
    </section>

    <footer id="footer" className="border-0 bg-white">
      <div className="container">

        <div className="footer-widgets-wrap pb-5 clearfix">

          <div className="row col-mb-50">
            <div className="col-md-8">

              <div className="widget clearfix">

                <img src="images/logoMafateSmall.png" alt="Footer Logo" className="alignleft" style={{width:'50%', maxWidth:'250px', marginTop: '-6px', paddingRight: '18px', borderRight: '1px solid #DDD'}} />

                <p>
                <Trans
                  i18nKey="accroche_bas"
                  defaults="..." // optional defaultValue
                  values={{ arg1: '...',arg2: '...'}}
                  components={{ italic: <i />, bold: <strong /> }}
                />
                </p>

                {/*
                <div className="line line-sm"></div>
                
                <div className="row">
                  <div className="col-lg-3 col-6 bottommargin-sm widget_links">
                    <ul>
                      <li><a href="#">Applications Mobiles</a></li>
                      <li><a href="#">Site Internet</a></li>
                      <li><a href="#">Nom de Domaine</a></li>
                      <li><a href="#">Emails professionnels</a></li>
                    </ul>
                  </div>

                  <div className="col-lg-3 col-6 bottommargin-sm widget_links">
                    <ul>
                      <li><a href="#">Société de services</a></li>
                      <li><a href="#">Expert-Comptable</a></li>
                      <li><a href="#">Avocat</a></li>
                      <li><a href="#">Restaurants</a></li>
                    </ul>
                  </div>

                  <div className="col-lg-3 col-6 bottommargin-sm widget_links">
                    <ul>
                      <li><a href="#">Chanteurs/Groupe</a></li>
                      <li><a href="#">Artistes</a></li>
                      <li><a href="#">Événementiel</a></li>
                      <li><a href="#">Magazine</a></li>
                    </ul>
                  </div>

                  <div className="col-lg-3 col-6 bottommargin-sm widget_links">
                    <ul>
                      <li><a href="#">Coach / Formateur</a></li>
                      <li><a href="#">Photographes</a></li>
                      <li><a href="#">Radio / Podcasteur</a></li>
                      <li><a href="#">Influenceurs</a></li>
                    </ul>
                  </div>
                </div>
                */}

              </div>

            </div>

            <div className="col-md-4">
              {/*
              <div className="widget clearfix">

                <div className="row clearfix">
                  <div className="col-12 mt-4">
                    <div className="feature-box fbox-plain fbox-sm align-items-center">
                      <div className="fbox-icon">
                        <i className="icon-envelope text-dark"></i>
                      </div>
                      <div className="fbox-content">
                        <span className="text-muted">Email :</span><br />
                        <h3 className="nott ls0 fw-semibold">{t('hello@mafate.co')}</h3>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            */}

            {/*
              <div className="widget subscribe-widget clearfix">
                <h5><strong>{t('Subscribe')}</strong> {t('to our newsletter')}</h5>
                <div className="widget-subscribe-form-result"></div>
                <form id="widget-subscribe-form" action="https://api.mafate.co/v1.0/" method="post" className="mb-0">
                  <div className="input-group mx-auto">
                    <div className="input-group-text bg-transparent"><i className="icon-email2"></i></div>
                    <input type="email" id="widget-subscribe-form-email" name="widget-subscribe-form-email" className="form-control required email" placeholder="Email" />
                    <button className="btn btn-success button button-color nott ls0 m-0" type="submit">{t('btnSubscribe')}</button>
                  </div>
                </form>
              </div>
            */}

              <div className="widget">

                <div className="row col-mb-30">
                  <div className="col-lg-6 col-md-12 col-6">
                    <a href="https://facebook.com/mafate.co" target="_blank" className="social-icon si-dark si-colored si-facebook mb-0 marginRight10">
                      <i className="icon-facebook"></i>
                      <i className="icon-facebook"></i>
                    </a>
                    <a href="https://facebook.com/mafate.co" target="_blank" className="text-dark visible-*-block mt-3"><small style={{display: 'block', marginTop:'3px'}}><strong>{t('Follow Us')}</strong><br/>{t('On Facebook')}</small></a>
                  </div>
                  <div className="col-lg-6 col-md-12 col-6">
                    <a href="https://www.instagram.com/mafate.co" target="_blank" className="social-icon si-dark si-colored si-rss mb-0" style={{marginRight: '10px'}}>
                      <i className="icon-instagram2"></i>
                      <i className="icon-instagram2"></i>
                    </a>
                    <a href="https://www.instagram.com/mafate.co" target="_blank" className="text-dark"><small style={{display: 'block', marginTop: '3px'}}><strong>{t('Follow Us')}</strong><br/>{t('On Instagram')}</small></a>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <div id="copyrights" style={{background: 'url(demos/seo/images/hero/footer.svg) no-repeat top center', backgroundSize: 'cover', paddingTop: '70px'}}>
        <div className="container clearfix">

          <div className="row justify-content-between col-mb-30">
            <div className="col-12 col-lg-auto text-center text-lg-start">
              &copy; {new Date().getFullYear()} Mafate<br />
              <div className="copyright-links"><a href={termsHref}>{t('Terms of Use')}</a> / <a href={privacyHref}>{t('Privacy Policy')}</a></div>
            </div>

            <div className="col-12 col-lg-auto text-center text-lg-end">
              <div className="copyrights-menu copyright-links clearfix">
                <a href="#">{t('Home')}</a>/<a href="#services">{t('Services')}</a>/<a href="#pricing">{t('Pricing')}</a>/<a href={contactHref}>Contact</a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </footer>

  </div>
  </>
  );
}

export default App;
